var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{class:['loading-logo-wrap', { 'p-absolute': !_vm.isFullPage }]},[_c('div',{attrs:{"id":"loading-logo2"}}),_c('v-overlay',{attrs:{"z-index":"20","absolute":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }